// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".test-page[data-v-54e8c09e]{background:#fff;min-height:500px;padding:20px}.test-subtitle[data-v-54e8c09e],.test-title[data-v-54e8c09e]{margin:5px;font-weight:700}.test-subtitle[data-v-54e8c09e]{font-size:30px}.cancelButton[data-v-54e8c09e]{margin:10px}.submitButton[data-v-54e8c09e]{margin:10px;font-weight:700}", ""]);
// Exports
module.exports = exports;
